import {useCallback} from 'react';
import {CompetitionName, SearchTerm, Sport} from 'utils/types';
import useLocalStorage from './useLocalStorage';

type UseSearchHistoryResult = [
  {value: string; label: string}[],
  (item: {value: string; label: string}) => void,
  (index: number) => void
];

/**
 * Provides 5 last searches for search dropdown.
 */
const useSearchHistory = (): UseSearchHistoryResult => {
  const [history, setHistory] = useLocalStorage<{value: string; label: string}[]>(
    'sport24_matchcenter_search_history',
    []
  );

  const addItem = useCallback(
    item => {
      const existing = history.find(h => h.value === item.value);
      if (existing) return;

      const newHistory = [...history];
      const length = newHistory.unshift(item);
      if (length > 5) newHistory.splice(5);
      setHistory(newHistory);
    },
    [history, setHistory]
  );

  const removeItem = useCallback(
    (index: number) => {
      const newHistory = [...history];
      newHistory.splice(index, 1);
      setHistory(newHistory);
    },
    [history, setHistory]
  );

  return [history, addItem, removeItem];
};

export default useSearchHistory;
